import { FormHolder, NullableFormValue } from "./index";
import { Component } from "react";
import { RememberThis } from "./decoratetors";

class StateHolder<T = any, XT = any> implements FormHolder<T, XT> {
	private readonly cmp: Component<any, any>;

	private constructor( cmp: Component ) {
		this.cmp = cmp;
	}

	@RememberThis()
	public static buildStateHolder( cmp: Component ) {
		return new StateHolder( cmp );
	}

	readValue( id: string ): NullableFormValue<T, XT> {
		if ( this.cmp && this.cmp.state ) {
			return this.cmp.state[ id ] as T;
		}
		return undefined;
	}

	writeValue( id: string, value: NullableFormValue<T, XT>, callback?: () => void ): NullableFormValue<T, XT> {
		if ( this.cmp && this.cmp.state ) {
			this.cmp.setState( { [ id ]: value }, callback );
			return value;
		}
		return undefined;
	}
}

export default StateHolder;
